import { render, staticRenderFns } from "./SpecialtyNav.vue?vue&type=template&id=ac057794&"
import script from "./SpecialtyNav.vue?vue&type=script&lang=js&"
export * from "./SpecialtyNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports